import {
  GetWorkAreaMapsDocument,
  GetWorkAreasDocument,
  UpdateWorkAreaMapDocument,
  UpdateWorkAreaMapMutation,
  UpdateWorkAreaMapMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateWorkAreaMap = () => {
  const [executeMutation] = useMutation(UpdateWorkAreaMapDocument, {
    extractorFn: (data: UpdateWorkAreaMapMutation) =>
      data.spaceControlMutations.updateSpacecontrolWorkAreaMap,
  })

  const updateWorkAreaMap = async (variables: UpdateWorkAreaMapMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [GetWorkAreaMapsDocument, GetWorkAreasDocument],
    })
  }

  return {
    updateWorkAreaMap,
  }
}
